export const engagementLandingPageTemplatesData = "/engagement/landing_page_templates_data";
